import classNames from 'classnames'
import React from 'react'
import { Analysis } from 'scenes/Dashboard/data/analyses/analyses.types'
import { Deal } from 'scenes/Dashboard/data/deals/types'
import { makeStyles } from 'tss-react/mui'
import { ExtendableStyles } from 'utils-next/types'

import { Grid, Theme } from '@mui/material'

import { AssessmentTable } from './components/AssessmentTable'

function AssessmentsView({ className, summary = false, analysis }: AssessmentsViewProps) {
  const { classes } = useStyles()

  const numColumnsPerTable = 12

  return (
    <div className={classNames(className, classes.checksContentContainer)}>
      <Grid className={classes.gridContainer} container justifyContent="center" spacing={1}>
        <Grid item md={numColumnsPerTable} xs={12}>
          <AssessmentTable onlyHeader={summary} tableTitle={'Analysis report'} analysis={analysis} />
        </Grid>
      </Grid>
    </div>
  )
}

export type AssessmentsViewProps = ExtendableStyles & {
  deal?: Deal
  analysis: Analysis
  summary?: boolean
}

const useStyles = makeStyles()(({ spacing }: Theme) => ({
  checksContentContainer: {
    marginBottom: spacing(4),
  },
  gridContainer: {
    display: 'flex',
  },
  caption: {
    display: 'block',
    marginTop: spacing(3),
  },
}))

export default AssessmentsView
